ko.bindingHandlers.setUrl = {
    update: function (element, valueAccessor, allBindingsAccessor) {
        const url = ko.unwrap(valueAccessor());
        const cancelOptions = allBindingsAccessor().cancelUrl || [];

        const lowerUrl = url.toLowerCase();

        const mustCancel = cancelOptions
            .map(i => i.toLowerCase())
            .some(i => lowerUrl.indexOf(i) > -1);

        if (url.length > 0 && url !== element.src && url.indexOf('about:blank') === -1 && !mustCancel) {
            //creates enough time to add 'sandbox' attribute in time to iframe
            setTimeout(() => {

                element.src = url;
            }, 0)

        }

    }
}